/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressRequest } from './address-request';

export interface DeckInvestmentCompanyCreateRequest {
  name: string;
  organization_number?: string | null;
  giin?: string | null;
  utl?: string | null;
  logo?: Blob;
  address: AddressRequest;
  website?: string;
  added_by: string;
}
